<spe-alert *ngIf="!showLoading" [class]="alertStatus" [message]="alertMessage"></spe-alert>

<!-- fase de carregamento do arquivo -->
<div class="row justify-content-center m-processing" *ngIf="showLoading">
  <div class="col-lg-6">
    <div class="text-center">
      <div class="spinner-border color-brand-principal mb-16" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>

      <h2 class="mb-8">{{ alertTitle }}</h2>
      <p>{{ alertMessage }}</p>
    </div>

    <div *ngIf="showStepCounters" class="background rounded-16 p-4">
      <div><b>Funcionários:</b>&nbsp;&nbsp;{{ employees }}</div>
      <div><b>Benefícios:</b>&nbsp;&nbsp;{{ benefits }}</div>
      <div><b>Erros:</b>&nbsp;&nbsp;{{ errors }}</div>
    </div>
  </div>
</div>

<div *ngIf="!showLoading" class="alert alert-warning">
  <span><b>Atenção!</b></span>
  <div>Foram encontrados inconsistências na importação do seu arquivo. Corrija seu arquivo importe novamente.</div>
</div>

<div *ngIf="(fieldList1.length > 0 || fieldList2.length > 0) && !showLoading">
  <form [formGroup]="mainFormGroup">
    <!-- *ngIf="!showStepFail && criticalErrors.length > 0 && addressTitle !== ''" -->
    <spe-titulo-sessao
      icone="assets/icones/cinza/dados-empresa.svg"
      [titulo]="`Empresa localizada no arquivo (${fieldList1.length} registro${fieldList1.length === 1 ? '' : 's'})`"
    ></spe-titulo-sessao>

    <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.field1)">
      <mat-label>Empresa localizada no arquivo</mat-label>
      <mat-select name="listAddressType" formControlName="field1">
        <mat-option *ngFor="let element of fieldList1" [value]="element.idImportacaoEndereco">
          {{ element.razaoSocial }} - {{ element.cpfCnpj | cnpj }}
        </mat-option>
      </mat-select>
      <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      <mat-error>{{ validatorErrors(mainFormGroup.controls.field1) }}</mat-error>
    </mat-form-field>
  </form>

  <spe-alert [class]="apiStatus" [message]="message"></spe-alert>
  <spe-alert [class]="alertStatus" [message]="alertMessage"></spe-alert>

  <div class="mt-8" *ngFor="let element of errorsToShow">
    <div>{{ element }}</div>
  </div>

  <spe-titulo-sessao
    icone="assets/icones/cinza/enderecos.svg"
    [titulo]="`Endereço de entrega localizado no arquivo (${fieldList2.length} registro${fieldList2.length === 1 ? '' : 's'})`"
  ></spe-titulo-sessao>

  <div class="listing-items"></div>

  <form [formGroup]="mainFormGroup">
    <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.field2)">
      <mat-label>Endereço de entrega localizado no arquivo</mat-label>
      <mat-select name="listAddressType" formControlName="field2">
        <mat-option *ngFor="let element of fieldList2" [value]="element.idImportacaoEndereco">
          {{ element.endereco }}
        </mat-option>
      </mat-select>

      <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      <mat-error>{{ validatorErrors(mainFormGroup.controls.field2) }}</mat-error>
    </mat-form-field>

    <spe-titulo-sessao
      icone="assets/icones/cinza/enderecos.svg"
      [titulo]="'Endereço de entrega cadastrado no site'"
    ></spe-titulo-sessao>
    <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.field3)">
      <mat-label>Endereço de entrega cadastrado no site</mat-label>

      <input type="text" formControlName="field4" matInput [matAutocomplete]="auto" />

      <button *ngIf="mainFormGroup.value.field4" matSuffix mat-icon-button (click)="clearInput()">
        <mat-icon>close</mat-icon>
      </button>

      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectOption($event)">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{ option.endereco }}
        </mat-option>
      </mat-autocomplete>
      <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
    </mat-form-field>
  </form>

  <div class="text-end">
    <button mat-stroked-button (click)="includeAddress()" class="me-2">Incluir Endereço</button>
    <button mat-flat-button (click)="associateAddress()">Associar Endereço</button>
  </div>
</div>

<div *ngIf="criticalErrors.data.length > 0 && !showLoading">
  <spe-titulo-sessao icone="assets/icones/cinza/error.svg" [titulo]="'Alertas'"></spe-titulo-sessao>

  <div *ngIf="!showStepFail && !showLoading">
    <div class="overflow-x-auto rounded-16">
      <table
        mat-table
        matTableResponsive-41
        matSort
        [dataSource]="criticalErrors"
        class="mat-elevation-z8 custom-table"
      >
        <!-- Descrição -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
          <td mat-cell *matCellDef="let element" data-label="Descrição">
            <div>
              <b>{{ element.value.DS_ERRUSU_EVT }}</b>
            </div>
            <div>{{ element.value.DS_ERRARQ_IRR }}</div>
          </td>
        </ng-container>

        <!-- Erro -->
        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Erro</th>
          <td mat-cell *matCellDef="let element" data-label="Erro">
            {{ element.key }}
          </td>
        </ng-container>

        <!-- Linha do Arquivo -->
        <ng-container matColumnDef="lineFile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Linha do Arquivo</th>
          <td mat-cell *matCellDef="let element" data-label="Linha do Arquivo">
            {{ element.value.DS_LINARQ_IRR }}
          </td>
        </ng-container>

        <!-- Linha do Real -->
        <ng-container matColumnDef="lineReal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Linha do Real</th>
          <td mat-cell *matCellDef="let element" data-label="Linha do Real">
            {{ element.value.CD_LINREA_IRR }}
          </td>
        </ng-container>

        <!-- Tipo -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
          <td mat-cell *matCellDef="let element" data-label="Tipo">
            <span class="status-chip" [ngClass]="showStatus(element).status">{{ showStatus(element).message }}</span>
          </td>
        </ng-container>

        <!-- Cabeçalhos e Linhas -->
        <tr mat-header-row *matHeaderRowDef="displayedColumnsTable"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsTable"></tr>
      </table>
    </div>
  </div>

  <div *ngIf="showStepFail && !showLoading">
    <h2>Verificação de dados</h2>
    <p class="font-size-14 mt-8">
      Caso tenha dúvidas entre em contato com a
      <a
        href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)"
        >central de atendimento</a
      >
    </p>
  </div>

  <div *ngIf="!showStepFail && !showLoading">
    <div class="mt-16 text-end" *ngIf="showContinue">
      <button mat-flat-button [ngClass]="{ caixaButton: sigla == 'CAIXA' }" (click)="continueButton()">
        Continuar
      </button>
    </div>

    <div class="mt-16 text-end" *ngIf="!showContinue">
      <button *ngIf="showExtractButton && !showLoading" class="me-2" mat-stroked-button (click)="extractErrors()">
        Extrair Erros
      </button>
      <button mat-stroked-button (click)="apbButton()" class="me-2">Arquivo formato APB</button>
      <button mat-flat-button (click)="csvButton()">Relatório CSV</button>
    </div>
  </div>
</div>
